module.exports = __webpack_public_path__ + "img/XiaojunLi.d2c310d0.png";